<template>
	<v-img
		:src="`/images/flags/${countryCode.toLowerCase()}.svg`"
		width="32px"
		height="24px"
		v-bind="$attrs"
	/>
</template>
<script>
export default {
	props: {
		countryCode: {
			type: String,
			required: true
		}
	}
};
</script>

